module.exports = __webpack_public_path__ + "static/ADIDAS_CHEATSHEET-acb9aba7adb9d93e0a92b6530113d7bb.pdf";